import * as React from "react";
import PatientSummary from "./PatientSummary";
import "./NavigablePatientBar.scss";
import { NavigableUserCardRegular } from "../commons/components/user/UserCardRegular";

export default function NavigablePatientBar({ patients }: { patients: PatientSummary[] }) {
  return (
    <div className="patient-bar">
      <div className="patient-list">
        {patients.map((it, index) => (
          <NavigableUserCardRegular
            key={it.uid}
            userInfo={it}
            path={index == 0 ? "/" : `/${it.uid}`}
          />
        ))}
      </div>
    </div>
  );
}
